import React from "react";
import Html5 from "../icons/html5.jsx";
import Css3 from "../icons/css3-alt.jsx";
import JS from "../icons/js.jsx";
import Sass from "../icons/sass.jsx";
import Bootstrap from "../icons/bootstrap.jsx";
import Nodejs from "../icons/node-js.jsx";
import ReactSvg from "../icons/react.jsx";
export default function Skills() {
  return (
    <section className="skills_section" id="skills">
      <div className="container">
        <h1 className="skills_heading d-flex align-items-center">
          <span className="skill-divider"></span> &nbsp; Skills
        </h1>
      </div>
      <div className="skills_container">
        <div className="row">
          <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div className="img img-html">
              <Html5 />
              <p>HTML5 · Intermidiate Level</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div className="img img-css">
              <Css3 />
              <p>CSS3 · Intermidiate Level</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div className="img img-js">
              <JS />
              <p>JS · Intermidiate Level</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div className="img img-sass">
              <Sass />
              <p>SASS · Beginner Level</p>
            </div>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="img img-bootstrap">
              <Bootstrap />
              <p>Bootstrap · Intermidiate Level</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="img img-node">
              <Nodejs />
              <p>NodeJS · Beginner Level</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="img react">
              <ReactSvg />
              <p>ReactJS · Beginner Level</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
